import React from "react"
import Layout from "../components/layout"

const About = () => (
  <Layout>
    About Page
    <p>
      Lorem, ipsum dolor sit amet consectetur adipisicing elit. Voluptates quam
      sunt labore impedit in exercitationem, nisi ullam reprehenderit, inventore
      obcaecati, fugit enim illum placeat! Consequuntur optio doloremque
      repellat omnis sunt!
    </p>
  </Layout>
)

export default About
